export const METRIC_LIST_QUERY_KEY = 'METRIC_LIST_QUERY_KEY';

export const actionTypes = {
  RESET: 'reset',
  DELETE: 'delete',
  SAVE: 'save',
};

export type TActionType = (typeof actionTypes)[keyof typeof actionTypes] | null;
